import React, { Component } from 'react'
import { Motion, spring } from 'react-motion'
import PropTypes from 'prop-types'
import Swipeable from 'react-swipeable'

const ARROW_POLY = (
  <polygon points="105.8,50.2 28.1,50.2 71.1,10.3 61.6,0 0,57.3 61.6,114.5 71.1,104.2 28.1,64.2 105.8,64.2 " />
)

const SLIDE_WIDTH = 86
const BORDER_WIDTH = (100 - SLIDE_WIDTH) / 2

export default class CarouselImages extends Component {
  constructor(props) {
    super(props)
    var newSlides = this.props.slides
    newSlides.unshift(this.props.slides[this.props.slides.length - 1])
    newSlides.push(this.props.slides[1])
    newSlides.push(this.props.slides[2])
    this.state = {
      index: 2,
      slides: newSlides,
      slidesLength: newSlides.length,
      immediate: false
    }
    this.INTERVAL = 3000
    this.instant = true
  }

  goLeft() {
    if (this.state.index === 0) {
      this.setState({ index: this.state.slidesLength - 3 }, () => {
        this.goLeft()
      })
    } else {
      this.setState({ index: this.state.index - 1 })
    }
  }

  goRight() {
    if (this.state.index === this.state.slidesLength - 3) {
      this.setState({ index: 0 }, () => {
        this.goRight()
      })
    } else {
      this.setState({ index: this.state.index + 1 })
    }
  }

  move(index) {
    if (this.state.slidesLength - 1 - (index + this.state.index) === 0) {
      this.goLeft()
    } else if (this.state.slidesLength - 1 - (index + this.state.index) === 2) {
      this.goRight()
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (
      (this.state.index === 0 &&
        nextState.index === this.state.slidesLength - 3) ||
      (this.state.index === this.state.slidesLength - 3 &&
        nextState.index === 0)
    ) {
      this.instant = true
    } else {
      this.instant = false
    }
  }

  render() {
    let xTranslate = -(this.state.index + 1) * SLIDE_WIDTH + BORDER_WIDTH
    return (
      <Swipeable
        onSwipedLeft={this.goRight.bind(this)}
        onSwipedRight={this.goLeft.bind(this)}
      >
        <svg
          viewBox="0 0 105.8 114.5"
          className={
            this.props.className +
            '-arrow ' +
            this.props.className +
            '-arrow--left'
          }
          onClick={this.goLeft.bind(this)}
        >
          {ARROW_POLY}
        </svg>
        <Motion style={{ x: this.instant ? xTranslate : spring(xTranslate) }}>
          {({ x }) => (
            <div
              className={this.props.className}
              style={{
                width: this.state.slidesLength * SLIDE_WIDTH + 'vw',
                transform: `translate(${x}vw, 0)`
              }}
            >
              {this.state.slides.map((slide, i) => {
                // let key = Object.keys(slide)[0]
                let media = (
                  <img
                    className={this.props.className + '-slide-image'}
                    src={'../public/img/' + slide.src}
                    alt=""
                  />
                )
                //  if (slide.type === 'youtube') {
                //    media = <div className="intrinsic-container"><iframe className={this.props.className + '-slide-image ' + this.props.className + '-slide-video'} src={"https://www.youtube-nocookie.com/embed/" + slide.src + "?rel=0"} allowFullScreen></iframe></div>
                //  }
                return (
                  <div
                    className={
                      this.props.className + '-slide ' + this.props.className
                    }
                    key={i}
                    style={{ width: SLIDE_WIDTH + 'vw' }}
                    onClick={this.move.bind(this, i)}
                  >
                    {media}
                    <div
                      className={
                        this.props.className +
                        '-slide-text' +
                        (this.state.slidesLength -
                          1 -
                          (i + this.state.index) !==
                        1
                          ? ' ' +
                            this.props.className +
                            '-slide-text--invisible'
                          : '')
                      }
                      dangerouslySetInnerHTML={{ __html: slide.text }}
                    />
                  </div>
                )
              })}
            </div>
          )}
        </Motion>
        <svg
          viewBox="0 0 105.8 114.5"
          className={
            this.props.className +
            '-arrow ' +
            this.props.className +
            '-arrow--right'
          }
          onClick={this.goRight.bind(this)}
        >
          {ARROW_POLY}
        </svg>
      </Swipeable>
    )
  }
}

CarouselImages.propTypes = {
  slides: PropTypes.array.isRequired,
  interval: PropTypes.number,
  className: PropTypes.string.isRequired
}



/** WEBPACK FOOTER **
 ** ./src/components/carouselimages.js
 **/